<template>
  <div>
    <NavBar class="trade-section__navbar" sticky>
      <template #left>
        <BackButton @click="onBackClick" />
      </template>
      <template v-if="!loading" #center>
        {{ sectionDetail.category }}
      </template>
    </NavBar>
    <div class="trade-section__wrapper">
      <div class="trade-section__content">
        <DetailLoader v-if="loading" />
        <Section
          v-else
          :title="sectionDetail.title"
          :subtitle="sectionDetail.description"
          size="2"
        >
          <FiltersList
            :filters="sectionDetail.filters"
            class="trade-section__filters"
            @select-filter="handleSelectFilter"
          />
          <InstrumentList
            :on-row-click="onRowClick"
            :search-items-data="sectionDetail.items"
            class="trade-section__instruments"
          />
        </Section>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { NavBar, IFilterOption } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { Section } from '@/modules/trade/components/Section';
import { DetailLoader } from './components/DetailLoader';
import { FiltersList } from '@/modules/trade/components/FiltersList';
import { InstrumentList } from '@/modules/trade/components/InstrumentList';

import {
  SectionDetail,
  getSectionDetail,
  Instrument
} from '@/modules/trade/services/search';
import {
  trackSectionViewLoad,
  trackFilterClick,
  trackInstrumentClick
} from './trackers';

@Component({
  components: {
    NavBar,
    BackButton,
    Section,
    FiltersList,
    InstrumentList,
    DetailLoader
  }
})
export default class SearchSectionDetailView extends Vue {
  private sectionDetail!: SectionDetail;
  private loading = true;
  private error = false;

  private handleSelectFilter(filter: IFilterOption) {
    trackFilterClick(this.sectionDetail.title, filter.label);
    this.load(filter.value);
  }

  async load(filter: string) {
    this.loading = true;
    this.error = false;
    try {
      const data = await getSectionDetail(this.$route.params.id, filter);
      this.sectionDetail = data;
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  private async created() {
    await this.load('all');
    trackSectionViewLoad(this.sectionDetail?.title || '');
  }

  private onBackClick() {
    this.$router.back();
  }

  private onRowClick(instrument: Instrument) {
    trackInstrumentClick(
      this.sectionDetail.title,
      instrument.symbol,
      instrument.name!
    );

    this.$router.push({
      name: 'tradeInstrument',
      params: { ticker: instrument.symbol }
    });
  }
}
</script>

<style lang="less" scoped>
.trade-section {
  &__navbar {
    margin-bottom: @size-spacing-x1100;
  }
  &__wrapper {
    background-color: @background-secondary;
    width: 100%;
    padding: 0 @size-spacing-x400;
  }
  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
  &__filters {
    margin-top: @size-spacing-x800;
  }
  &__instruments {
    margin-top: @size-spacing-x400;
  }
}

@media @notebookUp {
  .trade-section__wrapper {
    padding: 0 @size-spacing-x800;
  }
}
</style>
